import { render } from "./AIinspection.vue?vue&type=template&id=6958b18a&scoped=true"
import script from "./AIinspection.vue?vue&type=script&lang=js"
export * from "./AIinspection.vue?vue&type=script&lang=js"

import "./AIinspection.vue?vue&type=style&index=0&id=6958b18a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6958b18a"

export default script